import { Component, OnInit, ViewChildren, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TestRequestService } from '../../services/test-request.service';
import { UserService } from '../../services/userService';
import { AuthService } from '../../services/auth.service';
import { HelperService } from '../../services/helper.service';
import { Source } from '../../models/Source';
import { Test } from '../../models/Test';
import { User } from '../../models/User';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { TestService } from '../../services/test.service';
//import { TestGroup } from '../../models/TestGroup';
import { TestRequest } from '../../models/TestRequest';
import { NeedsKitModal } from './needskit.modal'
import { NeedsVenousModal } from './needsvenous.modal'
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { SourceService } from '../../services/source.service';

@Component({
  selector: 'app-newrequest',
  standalone: true,
  imports: [
    DatePipe,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './newrequest.component.html',
  styleUrl: './newrequest.component.css'
})
export class NewrequestComponent implements OnInit {

  id: string ="";
  testRequest: TestRequest = new TestRequest();
  newRequestForm: FormGroup = new FormGroup({
    hospitalNo: new FormControl('', { nonNullable: true }),
    reference: new FormControl('', { nonNullable: true }),
    attendingDr: new FormControl('', { nonNullable: true }),
    accountTo: new FormControl('', { nonNullable: true }),
    isGrey: new FormControl(false, { nonNullable: true }),
    isFasting: new FormControl(false, { nonNullable: true }),
    needsKit: new FormControl(false, { nonNullable: true }),
    needsVenous: new FormControl(false, { nonNullable: true }),
    sampleDate: new FormControl('', { nonNullable: true }),
    sampleTime: new FormControl('', { nonNullable: true }),
    surname: new FormControl('', { nonNullable: true }),
    forename: new FormControl('', { nonNullable: true }),
    title: new FormControl('', { nonNullable: true }),
    sex: new FormControl('', { nonNullable: true }),
    dob: new FormControl('', { nonNullable: true }),
    phone: new FormControl('', { nonNullable: true }),
    address1: new FormControl('', { nonNullable: true }),
    address2: new FormControl('', { nonNullable: true }),
    address3: new FormControl('', { nonNullable: true }),
    postCode: new FormControl('', { nonNullable: true }),
    email: new FormControl('', { nonNullable: true }),
    insuranceNum: new FormControl('', { nonNullable: true }),
    insuranceCo: new FormControl('', { nonNullable: true }),
    clinDets: new FormControl('', { nonNullable: true })
  });
  UserSource: Source = new Source();
  SelectedTests: Test[] =[];
  Top10Tests: Test[] =[];
  SexSelection: string ="";
  otherTitle: boolean = false;
  Message: string = "";
  maxDate: Date = new Date();
  today: any;
  testControl: FormControl = new FormControl();
  Tests: Test[] = [];
  showTestDropDown: boolean = false;
  base64: string = "";
  user: User = new User();
  @ViewChildren('testControl') testInput: ElementRef = new ElementRef(null);

  constructor(private formBulder: FormBuilder,
    private testRequestService: TestRequestService,
    public dialog: MatDialog,
    private userService: UserService,
    private authService: AuthService,
    private helperService: HelperService,
    private testService: TestService,
    private sourceService: SourceService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.testRequest.IsGrey = false;
    this.testRequest.IsFasting = false;
    this.testRequest.NeedsKit = false;
    this.testRequest.NeedsVenous = false;
    //this.testRequest.SampleDate = new Date();
    this.buildForm();
    this.maxDate = new Date();
    //this.today.year = this.maxDate.getFullYear();
    //this.today.month = this.maxDate.getMonth() + 1;
    //this.today.day = this.maxDate.getDate();
    this.SelectedTests = [];
    this.UserSource = this.authService.getLoginSource() || new Source();
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user;
      this.activatedRoute.queryParams.subscribe(params => {
        let id = params['id'];
        if (id) {
          this.id = id;
          this.testRequestService.getTestRequest(id).subscribe(data => {
            this.testRequest = data;
            this.testRequest.IsGrey = false;
            this.testRequest.IsFasting = false;
            this.testRequest.NeedsKit = false;
            this.SelectedTests = data.Tests;
            //this.newRequestForm.reset();
            this.buildForm();
            this.setSampleDateDefaults();
            this.setDOBDefaults();
            this.setAddressValidations();
          });
        }
        else {
          this.buildForm();
          this.setSampleDateDefaults();
          this.setAddressValidations();
        }
      });

      console.log(this.user);
      this.sourceService.getTop10Tests(this.user.Site, this.UserSource.Id).subscribe(tests => this.Top10Tests = tests);
      this.testControl.valueChanges.subscribe((filter: string) => {
        this.showTestDropDown = true;
        if (filter.length > 1) {
          this.testService.filterTests(this.user.Site, filter, this.UserSource.SourceCode).subscribe(data => {
            console.log(this.testRequest);
            if (this.testRequest.NeedsKit) {
              var validTests = data.filter(tst => { return tst.CanBeOrdered4Kits === true; })
              this.Tests = validTests;
            }
            else {
              this.Tests = data;
            }
          });
        }
        else {
          this.Tests = [];
        }
      })
    });
  }

  selectTest($event : any, test : Test) {
    //console.log(i, test);
    //console.log('selected ', this.isSelected(test));
    if (!this.isSelected(test)) {
      this.SelectedTests.push(test);
      this.showTestDropDown = !this.showTestDropDown;
      this.testControl.setValue('');
      //this.testInput.nativeElement.focus();
    }
  }

  //displayFn(test) {
  //  return '';
  //}
  onKey($event : any) {
    console.log($event);
  }

  removeTest(test : Test) {
    console.log(test);
    this.SelectedTests = this.helperService.RemoveItemFromArray(this.SelectedTests, test, (item : any) => { return item.Id == test.Id; });
  }

  isSelected(test: Test): boolean {
    return this.helperService.Exists(this.SelectedTests, (item : any) => { return test.TestCode == item.TestCode; });
  }

  //sanitize(url: string) {
  //  return this.sanitizer.bypassSecurityTrustUrl(url);
  //}

  openDialog(event: any) {
    //console.log(this.newRequestForm.get('needsKit').value);
    if ((this.newRequestForm.get('needsKit')?.value || false)) {
      const dialogRef = this.dialog.open(NeedsKitModal);
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        switch (result) {
          case true:
            //this.testRequest.AccountTo = 'D';
            //this.newRequestForm.get('accountTo').setValue('D');
            this.testRequest.NeedsKit = true;
            this.newRequestForm.get('needsVenous')?.setValue(false)
            this.newRequestForm.get('needsVenous')?.setValue(false);
            break;
          case false:
            this.testRequest.NeedsKit = false;
            this.newRequestForm.get('needsKit')?.setValue(false);
            this.newRequestForm.get('needsVenous')?.setValue(false);
            console.log(this.testRequest);
            break;
        }
      });
    }
    else {
      this.testRequest.NeedsKit = false;
      this.testRequest.NeedsVenous = false;
    }

    /*
    if (this.newRequestForm.get('needsVenous').value) {
      const dialogRef = this.dialog.open(NeedsKitModal);
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        switch (result) {
          case true:
            //this.testRequest.AccountTo = 'D';
            //this.newRequestForm.get('accountTo').setValue('D');
            this.testRequest.NeedsVenous = true;
            this.newRequestForm.get('needsKit').setValue(false);
            break;
          case false:
            this.testRequest.NeedsKit = false;
            this.newRequestForm.get('needsKit').setValue(false);
            this.newRequestForm.get('needsVenous').setValue(false);
            console.log(this.testRequest);
            break;
        }
      });
    }
    else {
      //this.testRequest.NeedsKit = false;
      this.testRequest.NeedsVenous = false;
    }
    */
    if (this.newRequestForm.get('needsVenous')?.value) {
      const dialogRef = this.dialog.open(NeedsVenousModal);
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        switch (result) {
          case true:
            this.testRequest.NeedsVenous = false;
            this.newRequestForm.get('needsVenous')?.setValue(false);
            break;
        }
      });
    }
    else {
      //this.testRequest.NeedsKit = false;
      this.testRequest.NeedsVenous = false;
    }

  }


  submitRequest(requestData : any) {
    requestData.tests = this.SelectedTests;
    //const sampleDateTime = requestData.sampleDate + 'T' + requestData.sampleTime;
    const sampleDateTime = requestData.sampleTime === undefined || requestData.sampleTime == '' ? requestData.sampleDate : requestData.sampleDate + 'T' + requestData.sampleTime;
    console.log(sampleDateTime);//22/10/20T12:00T12:00T12:00T12:00
    //requestData.sampleDate = sampleDateTime.toLocaleString().substring(0, 14);
    requestData.UserSourceId = this.UserSource.UserSourceId;
    requestData.Source = this.UserSource;
    requestData.Clinician = this.user.Clinician;
    console.log(requestData);
    this.Message = '';
    requestData.NeedsKit = this.user.CanOrderKits == true ? requestData.needsKit : false;
    requestData.NeedsVenous = this.user.CanOrderKits == true ? requestData.needsVenous : false;

    switch (requestData.NeedsKit == true || requestData.NeedsVenous == true) {
      case true:
        //requestData.accountTo = 'D';
        this.testRequestService.submitTestRequestNoPdf(requestData).then(response => {
          //console.log(response);
          let id = response;
          this.router.navigate(['manage/request-details'], { queryParams: { id: id } });
        });
        break;
      default:
        this.testRequestService.submitTestRequest(requestData).then((response : any) => {
          this.saveToFileSystem(response)
        });
        break;
    }
  }

  private saveToFileSystem(response : any) {
    //console.log(response);
    const contentDispositionHeader: string = response.headers.get('content-disposition');
    const id: string = response.headers.get("x-id");
    const parts: string[] = contentDispositionHeader.split(';');
    const filename = parts[1].split('=')[1];
    //console.log(filename);
    //const blob = new Blob([response.body], { type: 'text/plain' });
    saveAs(response.body, filename);
    console.log("id = ", id);
    this.router.navigate(['manage/request-details'], { queryParams: { id: id } });
  }

  onSexSelectionChange(event: any) {
    this.SexSelection = event.target.value;
  }

  onTitleSelectionChange(event: any) {
    console.log(event.target.value);
    if (event.target.value == "OTHER") {
      this.otherTitle = true;
      this.newRequestForm.controls["title"].setValue("");
    }
    else {
      this.testRequest.Title = event.target.value;
    }
  }

  TestsArevalid(): boolean {
    var wrongTestOrdered = this.SelectedTests.findIndex((tst, i) => tst.CanBeOrdered4Kits == false && (this.testRequest.NeedsKit || this.testRequest.NeedsVenous))
    //console.log("isvalid:", wrongTestOrdered, this.testRequest);
    var wrongTestMessage = wrongTestOrdered === -1 ? "" : `${this.SelectedTests[wrongTestOrdered].TestCode} cannot be ordered for home collection.`;
    this.Message = `At least 1, up to 10 tests must be ordered; ${wrongTestMessage}`;
    return this.SelectedTests.length > 0 && this.SelectedTests.length <= 10 && (wrongTestOrdered == -1);
  }

  isFormInValid() {
    //this.Message = this.newRequestForm.errors.join('\r\n');
    this.Message = this.newRequestForm.invalid ? "invalid" : "";
    return this.newRequestForm.invalid || !this.TestsArevalid();
  }

  setAddressValidations() {
    const addressControls = [this.newRequestForm.get('address1'), this.newRequestForm.get('address2'), this.newRequestForm.get('postCode')]
    this.newRequestForm.get('accountTo')?.valueChanges.subscribe(accountTo => {
      //console.log(accountTo)
      if (accountTo === 'P') {
        addressControls.forEach(control => {
          control?.setValidators([Validators.required]);
          control?.updateValueAndValidity();
          console.log(control);
        });
      }
      else {
        addressControls.forEach(control => {
          control?.setValidators(null)
          control?.updateValueAndValidity();
        });
      }
    })
    this.newRequestForm.get('needsKit')?.valueChanges.subscribe(needsKit => {
      //console.log(needsKit)
      if (needsKit === true) {
        addressControls.forEach(control => {
          control?.setValidators([Validators.required]);
          control?.updateValueAndValidity();
          //console.log(control);
        });
      }
      else {
        addressControls.forEach(control => {
          control?.setValidators(null)
          control?.updateValueAndValidity();
        });
      }
    })
  }
  setSampleDateDefaults() {
    //this.newRequestForm.controls['sampleDate'].setValue(this.maxDate.toISOString().substring(0, 10));//yyyy-mm-dd
    //console.log('sampleDate', this.newRequestForm.controls['sampleDate'].value);
    this.newRequestForm.controls['accountTo'].setValue('D');
  }

  setDOBDefaults() {
    this.newRequestForm.controls['dob'].setValue(this.testRequest.Dob.toString().substring(0, 10));
  }

  buildForm() {
    this.newRequestForm = this.formBulder.group({
      hospitalNo: this.testRequest.HospitalNo,
      reference: '',
      attendingDr: this.testRequest.AttendingDr,
      accountTo: [this.testRequest.AccountTo, Validators.required],
      isGrey: this.testRequest.IsGrey,
      isFasting: this.testRequest.IsFasting,
      needsKit: this.testRequest.NeedsKit,
      needsVenous: this.testRequest.NeedsVenous,
      sampleDate: '',
      sampleTime: '',//['', [Validators.pattern('^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$')]],
      surname: [this.testRequest.Surname, Validators.required],
      forename: [this.testRequest.ForeName, Validators.required],
      title: this.testRequest.Title,
      sex: [this.testRequest.Sex, Validators.required],
      dob: [this.testRequest.Dob, Validators.required],
      phone: this.testRequest.Phone,
      address1: this.testRequest.Address1,
      address2: this.testRequest.Address2,
      address3: this.testRequest.Address3,
      postCode: this.testRequest.PostCode,
      email: this.testRequest.Email,
      insuranceNum: this.testRequest.InsuranceNum,
      insuranceCo: this.testRequest.InsuranceCo,
      clinDets: this.testRequest.ClinDets
      //clinician: this.user.Clinician
    });
  }
}
